<div class="effect" aria-live="polite">
  <div class="body">
    @if (rangeText || scope) {
      <div class="range">{{ rangeText }}@if (scope) {<span class="scope"> {{ scope }}</span>}</div>
    }
    @if (vm.due) {
      <div class="due">{{ vm.due }}</div>
    }
    @if (vm.credit) {
      <div class="credit">{{ vm.credit }}</div>
    }
    @if (vm.net) {
      <div class="net">Écart net : <b class="amt">{{ vm.net.ht }}</b> HT · <span class="amt">{{ vm.net.ttc }}</span> TTC</div>
    }
    @for (t of vm.dayCounts; track $index) {
      <div class="days">{{ t }}</div>
    }
    @for (t of vm.sales; track $index) {
      <div class="sale">{{ t }}</div>
    }
    @if (vm.blocked) {
      <span [class]="vm.blocked.cls">{{ vm.blocked.text }}</span>
    }
    @for (w of warnings; track $index) {
      <span class="warn">{{ w }}</span>
    }
    @for (e of errors; track $index) {
      <span class="err">{{ e }}</span>
    }
    @if (state.error) {
      <span class="err server">{{ state.error }}</span>
    }
    @if (vm.details.length) {
      <details>
        <summary>Détail par matériel</summary>
        @for (d of vm.details; track $index) {
          <div class="detail">{{ d }}</div>
        }
      </details>
    }
  </div>
  @if (state.loading) {
    <mat-spinner class="spin" diameter="16" aria-label="Calcul en cours"></mat-spinner>
  }
</div>
